export interface FeedPost {
    id: string;
    type: 'news' | 'event';
    title: string;
    summary: string | null;
    content: string | null;
    eventLocation: string | null;
    isUrgent: boolean;
    keywords: string[];
    imageUrl: string | null;
    thumbnailUrl: string | null;
    duration: number | null;
    sourceUrl: string | null;
    sourceName: string | null;
    sourceType: 'facebook' | 'rss' | null;
    publishedAt: string;
    category: FeedCategory | null;
    eventDates: EventDate[];
    images: PostImage[];
    translatedTitle?: string;
    translatedSummary?: string;
    translatedContent?: string;
}

export interface FeedCategory {
    id: string;
    name: string;
    displayName: string;
    icon: string | null;
    color: string | null;
}

export interface EventDate {
    id: string;
    eventDate: string;
    startTime: string | null;
    endTime: string | null;
    notes: string | null;
    sortOrder: number;
}

export interface PostImage {
    id: string;
    imageUrl: string;
    originalUrl: string | null;
    caption: string | null;
    sortOrder: number;
    thumbnailUrl: string | null;
    duration: number | null;
    width: number | null;
    height: number | null;
    mediaType: string | null;
}

/**
 * Check if a media type represents a video
 */
export function isVideoMedia(mediaType: string | null | undefined): boolean {
    if (!mediaType) return false;
    return mediaType.toLowerCase().startsWith('video/');
}

/**
 * Format duration in seconds to mm:ss format
 */
export function formatDuration(seconds: number | null | undefined): string {
    if (!seconds || seconds <= 0) return '';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
}

export interface FeedSource {
    id: string;
    type: 'facebook' | 'rss';
    name: string;
    status: string;
}

export interface FeedFilters {
    search?: string;
    categoryId?: string;
    sourceName?: string;
    onlyUrgent?: boolean;
    onlyEvents?: boolean;
    sortBy?: 'publishedAt' | 'eventDate';
    sortOrder?: 'asc' | 'desc';
}

export interface FeedListResponse {
    posts: FeedPost[];
    total: number;
    page: number;
    pageSize: number;
    totalPages: number;
}
